<script>
  import {viewCard} from '~/Library/helpers'
  import LinkMolecule from '~/Components/Molecules/Link'
  export let card = {}
  export let index
</script>


<div class="card" on:click={viewCard(index)}>

  {#if card.image}

    <img src={card.image.publicUrlTransformed} alt="" class="card__icon">

  {/if}

  <div class="card__content">

    <h4 class="card__headline">{card.title}</h4>

    <p class="card__text">{card.description}</p>

    <LinkMolecule cta="Learn more" className="accent" callback={viewCard(index)} />

  </div>

</div>

<style lang="scss">
  .card {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    cursor: pointer;

    box-shadow: 0px 30px 50px rgba(95, 105, 131, 0.08);
    background: white;
    border-radius: 1rem;

    min-width: 30%;
    max-width: 30%;
    height: auto;
    z-index: 10;

    margin-right: 1rem;
    margin-bottom: 1rem;

    &__content {
      display: flex;
      flex-direction: column;
      padding: 1rem 2rem;
      flex-grow: 1;
    }
    &__headline {
      font-weight: bold;
    }
    &__icon {
      width: 100%;
      object-fit: scale-down;
      height: 13rem;
    }
    &__text {
      margin: 0.5rem 0;
      font-size: 0.875rem;
      flex-grow: 1;
    }

    @media only screen and (max-width: 576px) {
      max-width: unset;
      height: fit-content;
      margin: unset;
      margin-bottom: 1rem;
    }

  }
</style>